/*
 * Ash: add-to-cart button-state feedback.
 *   • On click → button shows "Adding…" (spinner) in place.
 *   • On cart:update success → button shows "Added" (check) for
 *     ~1.4s, then restores the original label.
 *   • Cart drawer auto-open is delayed by DRAWER_HOLD_MS after an
 *     add so the button's "Added" state is actually visible before
 *     the drawer covers it.
 * No corner toast — the button-state + drawer opening are the
 * confirmation.
 */
(function () {
  if (window.__ashCartToastInit) return;
  window.__ashCartToastInit = true;

  var LOG = false;
  function log() { if (LOG && window.console) console.log.apply(console, arguments); }

  // Hold the cart-drawer auto-open for this long so the button's
  // "Added" state is actually visible before the drawer covers it.
  // Was 1200 ms — user reported that made ATC feel slow (they read
  // the drawer delay as button lag). 500 ms is still enough to see
  // the tick + "Added" flash before the drawer arrives.
  var DRAWER_HOLD_MS = 500;

  var BUTTON_SUCCESS_MS = 900;

  var ICON_CHECK =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M5 12l5 5L20 7"/></svg>';
  var ICON_SPINNER =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" class="ash-toast__spinner">' +
    '<path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';

  /* ============= BUTTON-STATE STYLES ============= */

  function injectStyles() {
    if (document.getElementById('ash-cart-toast-style')) return;
    var s = document.createElement('style');
    s.id = 'ash-cart-toast-style';
    s.textContent =
      '@keyframes ash-toast-spin{to{transform:rotate(360deg);}}' +
      '.ash-atc-state .ash-toast__spinner{animation:ash-toast-spin 0.8s linear infinite;}' +
      /* Button state overrides */
      '[data-ash-atc-busy]{position:relative!important;}' +
      /* Hide EVERY direct child of a busy button EXCEPT our overlay */
      '[data-ash-atc-busy] > *:not(.ash-atc-state){' +
      'visibility:hidden!important;opacity:0!important;' +
      '}' +
      '.ash-atc-state{' +
      'position:absolute!important;inset:0!important;z-index:2147483000;' +
      'display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;' +
      'color:inherit!important;font:inherit!important;line-height:1!important;' +
      'text-align:center!important;padding:0!important;' +
      'pointer-events:none;' +
      '}' +
      '.ash-atc-state > *{flex:0 0 auto!important;}' +
      '.ash-atc-state svg{display:block!important;flex-shrink:0!important;}' +
      /* Neutralise the theme's checkmark-burst overlay while we own the button */
      '[data-ash-atc-busy] .add-to-cart__added,' +
      '[data-ash-atc-busy] .add-to-cart-text{' +
      'display:none!important;' +
      '}';
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyles);
  } else {
    injectStyles();
  }

  /* ============= BUTTON STATE (in-place label swap) ============= */

  /* Do NOT hold direct button references across events — Horizon
     morphs sections on cart:update and the OLD button element becomes
     detached, while the NEW button in DOM inherits our
     `data-ash-atc-busy` attribute through the morph but not our
     overlay child. Instead, we mark buttons with the attribute and
     query DOM freshly on every state transition. */
  var buttonSuccessTimers = new WeakMap();

  function findAtcButton(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      '.add-to-cart-button, ' +
      '.sticky-add-to-cart__button, ' +
      'button[ref="addToCartButton"], ' +
      '.ash-inline-buy-now, ' +
      '.ash-buy-now__btn, ' +
      '[data-ash-cart-add]'
    );
  }

  function buildOverlay(state) {
    var overlay = document.createElement('span');
    overlay.className = 'ash-atc-state';
    overlay.innerHTML = state === 'success'
      ? ICON_CHECK + '<span>Added</span>'
      : ICON_SPINNER + '<span>Adding…</span>';
    return overlay;
  }
  function setButtonState(btn, state) {
    if (!btn) return;
    // Save the original inner HTML once so we can restore later.
    if (!btn.hasAttribute('data-ash-atc-original')) {
      btn.setAttribute('data-ash-atc-original', btn.innerHTML);
    }
    btn.dataset.ashAtcBusy = state;
    // Remove any existing overlay so we can re-render.
    var existing = btn.querySelector('.ash-atc-state');
    if (existing) existing.remove();
    btn.appendChild(buildOverlay(state));
    // Horizon's morph may run AFTER we append (either during the same
    // task or the next microtask) and wipe the overlay while keeping
    // the busy attribute — leaving the button visually empty. Set up
    // a short-lived MutationObserver to re-inject the overlay if it
    // gets removed while the busy attribute is still set. Auto-tears
    // down after 3s.
    if (btn.__ashOverlayObs) {
      btn.__ashOverlayObs.disconnect();
      clearTimeout(btn.__ashOverlayObsTimer);
    }
    try {
      var obs = new MutationObserver(function () {
        if (!btn.hasAttribute('data-ash-atc-busy')) return;
        if (btn.querySelector('.ash-atc-state')) return;
        var kind = btn.dataset.ashAtcBusy || state;
        btn.appendChild(buildOverlay(kind));
        log('[ash-toast] re-injected overlay after morph on', btn);
      });
      obs.observe(btn, { childList: true, subtree: false });
      btn.__ashOverlayObs = obs;
      btn.__ashOverlayObsTimer = setTimeout(function () {
        if (btn.__ashOverlayObs) btn.__ashOverlayObs.disconnect();
        btn.__ashOverlayObs = null;
      }, 3000);
    } catch (err) {}
  }

  function restoreButton(btn) {
    if (!btn) return;
    var orig = btn.getAttribute('data-ash-atc-original');
    if (orig != null) {
      btn.innerHTML = orig;
      btn.removeAttribute('data-ash-atc-original');
    }
    btn.removeAttribute('data-ash-atc-busy');
    var existing = buttonSuccessTimers.get(btn);
    if (existing) {
      clearTimeout(existing);
      buttonSuccessTimers.delete(btn);
    }
  }

  function markButtonPending(btn) {
    if (!btn) return;
    setButtonState(btn, 'pending');
    log('[ash-toast] pending on', btn);
  }

  function markButtonSuccess(btn) {
    if (!btn) return;
    setButtonState(btn, 'success');
    var timer = setTimeout(function () { restoreButton(btn); }, BUTTON_SUCCESS_MS);
    buttonSuccessTimers.set(btn, timer);
    log('[ash-toast] success on', btn);
  }

  // Requery the DOM every time — the button element carried through
  // Horizon's morph is what we need to update, and our earlier
  // reference in `pendingButtons` would be stale.
  function transitionAllPendingToSuccess() {
    var btns = document.querySelectorAll('[data-ash-atc-busy]');
    log('[ash-toast] transition to success: found', btns.length, 'button(s)');
    for (var i = 0; i < btns.length; i++) markButtonSuccess(btns[i]);
  }
  function restoreAllPending() {
    var btns = document.querySelectorAll('[data-ash-atc-busy]');
    for (var i = 0; i < btns.length; i++) restoreButton(btns[i]);
  }

  /* ============= CART EVENTS ============= */

  var lastCount = null;
  function extractItemCount(detail) {
    if (!detail) return null;
    // resource.item_count is the TOTAL cart count (from
    // product-form.js and ash-cart-add.js dispatches). Check it first.
    if (detail.resource && typeof detail.resource.item_count === 'number') return detail.resource.item_count;
    // data.itemCount is INCONSISTENT: product-form.js sets it to the
    // quantity added (e.g. 1), ash-cart-add.js sets it to the total.
    // Only use it as a last resort — we won't compare it to lastCount
    // because comparing "quantity added" to "old total" gives false
    // negatives (1 > 3 = false → we'd think it's a remove).
    if (detail.data && typeof detail.data.itemCount === 'number') return detail.data.itemCount;
    return null;
  }
  function seedInitialCount() {
    var bubble = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
    if (!bubble) return;
    var n = parseInt((bubble.textContent || '').trim(), 10);
    if (!isNaN(n)) lastCount = n;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seedInitialCount);
  } else {
    seedInitialCount();
  }

  function hasPendingInDom() {
    return !!document.querySelector('[data-ash-atc-busy="pending"]');
  }
  function onCartUpdate(e) {
    var count = extractItemCount(e && e.detail);
    log('[ash-toast] cart:update fired, count=', count, 'lastCount=', lastCount, 'hasPending=', hasPendingInDom());
    // If we have a button in pending state, this event MUST be a
    // response to that click — treat it as an add unconditionally.
    // Only fall back to count comparison for cart:update events
    // that didn't originate from a button we own (e.g. quantity
    // change from within an already-open drawer).
    var isAdd = hasPendingInDom();
    if (!isAdd && count != null && lastCount != null) {
      isAdd = count > lastCount;
    }
    if (count != null) lastCount = count;
    if (isAdd) {
      // Mark that an add just happened. Our patched cart-drawer
      // `showDialog` (below) checks this flag and delays the actual
      // dialog open by DRAWER_HOLD_MS so the "Added" state on the
      // button is visible before the drawer covers it.
      window.__ashAtcRecentAdd = true;
      requestAnimationFrame(transitionAllPendingToSuccess);
      // Clear the flag after the drawer would have opened + been shown.
      setTimeout(function () { window.__ashAtcRecentAdd = false; }, DRAWER_HOLD_MS + 500);
    } else {
      restoreAllPending();
    }
  }
  // Capture phase — must run BEFORE cart-drawer's bubble-phase
  // handler so the flag is set by the time cart-drawer's
  // #handleCartAdd calls this.showDialog().
  document.addEventListener('cart:update', onCartUpdate, true);
  document.addEventListener('cart:add', function () {
    requestAnimationFrame(transitionAllPendingToSuccess);
  });
  document.addEventListener('cart:added', function () {
    requestAnimationFrame(transitionAllPendingToSuccess);
  });
  document.addEventListener('cart:error', function () {
    restoreAllPending();
  });

  /* BUBBLE phase so ash-required-selection's capture-phase
     stopImmediatePropagation() blocks us on missing-selection clicks. */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var btn = findAtcButton(e.target);
    if (btn) markButtonPending(btn);
  }, false);
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var btn = findAtcButton(e.target);
    if (btn) markButtonPending(btn);
  }, false);

  // Patch cart-drawer-component.showDialog once available so the
  // auto-open after a cart-add waits DRAWER_HOLD_MS. Direct user
  // clicks on the cart icon still open instantly (no flag set).
  function patchCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.__ashHoldPatched) return;
    var proto = Object.getPrototypeOf(drawer);
    if (!proto || typeof proto.showDialog !== 'function') return;
    var orig = proto.showDialog;
    drawer.showDialog = function () {
      var self = this;
      var args = arguments;
      if (window.__ashAtcRecentAdd) {
        window.__ashAtcRecentAdd = false;
        setTimeout(function () { orig.apply(self, args); }, DRAWER_HOLD_MS);
      } else {
        orig.apply(self, args);
      }
    };
    drawer.__ashHoldPatched = true;
    log('[ash-toast] cart-drawer showDialog patched');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
  } else {
    patchCartDrawer();
  }
  // Retry patch a few times in case the custom element mounts late.
  var patchAttempts = 0;
  var patchInterval = setInterval(function () {
    patchCartDrawer();
    var d = document.querySelector('cart-drawer-component');
    if ((d && d.__ashHoldPatched) || ++patchAttempts > 20) clearInterval(patchInterval);
  }, 200);
})();
